module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "startExam commonStyle"
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingShow),
      expression: "!loadingShow"
    }]
  }, [_vm._v(_vm._s(_vm.examName))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnwser == 1),
      expression: "canAnwser == 1"
    }],
    staticStyle: {
      "margin-top": "46px"
    }
  }, [(_vm.attention) ? _c('div', {
    staticClass: "exam-attention",
    domProps: {
      "innerHTML": _vm._s(_vm.attention)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.queryParam.examinationId === '1456104630148509697') ? _c('div', {
    staticStyle: {
      "margin-bottom": "-15px"
    },
    attrs: {
      "id": "attention0"
    }
  }, [_c('group', [_c('cell', {
    attrs: {
      "value-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#1957e8"
    }
  }, [_c('span', [_vm._v("您本次就诊的科室是：")])])]), _vm._v(" "), _c('checker', {
    staticStyle: {
      "margin-top": "-10px",
      "padding-bottom": "10px",
      "margin-left": "10px"
    },
    attrs: {
      "default-item-class": "select-item",
      "selected-item-class": "select-item-selected"
    },
    model: {
      value: (_vm.commonData),
      callback: function($$v) {
        _vm.commonData = $$v
      },
      expression: "commonData"
    }
  }, _vm._l((_vm.depts), function(item, i) {
    return _c('checker-item', {
      key: item.id,
      attrs: {
        "value": item.dictValue
      }
    }, [_vm._v(_vm._s(item.dictName))])
  }))], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.currentModule.subjects), function(item, i) {
    return _c('div', {
      staticClass: "exam-div",
      attrs: {
        "id": 'attention' + i
      }
    }, [(item.subjectModel == 1) ? _c('div', {
      staticClass: "rater"
    }, [_c('group', {
      attrs: {
        "title": (i + 1) + '.' + item.choices.subjectName
      }
    }, [_c('rater', {
      staticStyle: {
        "padding": "10px 15px"
      },
      attrs: {
        "margin": 4,
        "max": item.choices.options.length,
        "active-color": "#1957e8"
      },
      nativeOn: {
        "click": function($event) {
          _vm.getGrape(item)
        }
      },
      model: {
        value: (item.rateruserAnswer),
        callback: function($$v) {
          _vm.$set(item, "rateruserAnswer", $$v)
        },
        expression: "item.rateruserAnswer"
      }
    }), _vm._v(" "), _c('em', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.rateruserAnswerTxt != ''),
        expression: "item.rateruserAnswerTxt !=''"
      }],
      staticClass: "serviceGrade"
    }, [_vm._v(_vm._s(item.rateruserAnswerTxt))]), _vm._v(" "), _vm._l((item.choices.options), function(subitem, subi) {
      return _c('x-textarea', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (subi == 0),
          expression: "subi==0"
        }],
        key: subi,
        staticClass: "inputClick",
        attrs: {
          "placeholder": '请输入' + subitem.supTitle,
          "autosize": ""
        },
        model: {
          value: (item.optionInput),
          callback: function($$v) {
            _vm.$set(item, "optionInput", $$v)
          },
          expression: "item.optionInput"
        }
      })
    })], 2)], 1) : _vm._e(), _vm._v(" "), (item.type === 1 && item.refSubjectOptions === '' && item.subjectModel == 3) ? _c('sortChoices', {
      ref: item.id,
      refInFor: true,
      attrs: {
        "choice": item
      },
      on: {
        "on-autoshow": _vm.setAutoShowBySelect
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 1) ? _c('choices', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refSubjectOptions === '' && item.subjectModel == 2),
        expression: "item.refSubjectOptions === '' && item.subjectModel ==2"
      }],
      ref: item.id,
      refInFor: true,
      attrs: {
        "choice": item
      },
      on: {
        "on-autoshow": _vm.setAutoShowBySelect
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 2 && item.subjectModel == 2) ? _c('multiple-choices', {
      ref: item.id,
      refInFor: true,
      attrs: {
        "multichoice": item
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 3) ? _c('judgement', {
      ref: item.id,
      refInFor: true,
      attrs: {
        "judge": item
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 4) ? _c('shortAnswer', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refSubjectOptions === ''),
        expression: "item.refSubjectOptions === ''"
      }],
      ref: item.id,
      refInFor: true,
      attrs: {
        "shortAnswer": item
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "btnGroup",
    staticStyle: {
      "margin": "25px 10px"
    },
    attrs: {
      "align": "center"
    }
  }, [(_vm.currentModuleIndex > 0) ? _c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingShow),
      expression: "!loadingShow"
    }],
    staticClass: "BtnCommonCss",
    nativeOn: {
      "click": function($event) {
        _vm.pre($event)
      }
    }
  }, [_vm._v("上一页")]) : _vm._e(), _vm._v(" "), (_vm.currentModuleIndex < _vm.modules.length - 1) ? _c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingShow),
      expression: "!loadingShow"
    }],
    staticClass: "BtnCommonCss",
    nativeOn: {
      "click": function($event) {
        _vm.next($event)
      }
    }
  }, [_vm._v("下一页")]) : _vm._e(), _vm._v(" "), (_vm.modules.length - 1 == _vm.currentModuleIndex) ? _c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingShow),
      expression: "!loadingShow"
    }],
    staticClass: "BtnCommonCss",
    nativeOn: {
      "click": function($event) {
        _vm.subCommit($event)
      }
    }
  }, [_vm._v("提 交")]) : _vm._e(), _vm._v(" "), (_vm.end) ? _c('div', {
    staticClass: "exam-attention",
    domProps: {
      "innerHTML": _vm._s(_vm.end)
    }
  }) : _vm._e()], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnwser == 2),
      expression: "canAnwser == 2"
    }],
    staticClass: "paper",
    staticStyle: {
      "margin-top": "46px",
      "font-size": "16px"
    }
  }, [(_vm.examType != '3' ||
    _vm.queryParam.examinationId == '1465190079348736001' ||
    _vm.queryParam.examinationId == '1456791426964987906' ||
    _vm.queryParam.examinationId == '1456819128948154369' ||
    _vm.queryParam.examinationId == '1456179716670992386' ||
    _vm.queryParam.examinationId == '1456104630148509697' ||
    _vm.queryParam.examinationId == '1456095600710320130' ||
    _vm.queryParam.examinationId == '1518840129137115138' ||
    _vm.queryParam.examinationId == '1519231804678414337'
  ) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('icon', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "30px"
    },
    attrs: {
      "type": "success",
      "is-msg": ""
    }
  }), _vm._v(" "), (_vm.queryParam.examinationId === '1420195726680981506' || _vm.queryParam.examinationId === '1517297378954620929') ? _c('div', [_vm._v("谢谢您的参与！")]) : _vm._e(), _vm._v(" "), (_vm.queryParam.examinationId !== '1338313084932235266' && _vm.queryParam.examinationId == '1519231804678414337' && _vm.queryParam.examinationId !== '1518840129137115138' && _vm.queryParam.examinationId !== '1420195726680981506' && _vm.queryParam.examinationId !== '1517297378954620929') ? _c('div', [_vm._v("谢谢您的宝贵意见，我们将持续改进，旨在为患者提供更加优质的医疗服务！")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.examType == '3') ? _c('div', {
    staticClass: "module-chart"
  }, [_c('grid', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.personModule.length > 1),
      expression: "personModule.length > 1"
    }],
    attrs: {
      "cols": _vm.personModule.length <= 3 ? _vm.personModule.length : 3,
      "show-lr-borders": false,
      "show-vertical-dividers": false
    }
  }, _vm._l((_vm.personModule), function(item, i) {
    return _c('grid-item', {
      key: i
    }, [_c('div', [_c('span', [_vm._v(_vm._s(item.score))]), _c('br'), _vm._v(_vm._s(item.moduleName) + "\n            ")])])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.examType == '3' && _vm.queryParam.examinationId !== '1465190079348736001' && _vm.queryParam.examinationId !== '1456791426964987906' && _vm.queryParam.examinationId !== '1456819128948154369' && _vm.queryParam.examinationId !== '1456179716670992386' && _vm.queryParam.examinationId !== '1456104630148509697' && _vm.queryParam.examinationId !== '1456095600710320130') ? _c('div', {
    staticClass: "text-center strip-div white-text l-font",
    staticStyle: {
      "background": "url('https://front.cd.jinxin-fertility.com/static/images/strip.png') no-repeat",
      "background-size": "100%",
      "background-position": "center"
    }
  }, [_c('div', [_vm._v("你的综合得分")])]) : _vm._e(), _vm._v(" "), (_vm.score > 0 &&
    _vm.queryParam.examinationId !== '1456791426964987906' &&
    _vm.queryParam.examinationId !== '1456819128948154369' &&
    _vm.queryParam.examinationId !== '1456179716670992386' &&
    _vm.queryParam.examinationId !== '1456104630148509697' &&
    _vm.queryParam.examinationId !== '1456095600710320130' &&
    _vm.queryParam.examinationId !== '1465190079348736001' &&
    _vm.queryParam.examinationId !== '1518840129137115138' &&
    _vm.queryParam.examinationId !== '1519231804678414337'
  ) ? _c('div', {
    staticClass: "xxl-font text-center",
    staticStyle: {
      "color": "#1957e8"
    }
  }, [_c('span', {
    attrs: {
      "id": "total"
    }
  }, [_vm._v(_vm._s(_vm.score))]), _vm._v("分")]) : _vm._e(), _vm._v(" "), (_vm.examType == '3' && _vm.evalLevel != '' && (_vm.evalLevel == '无症状' || _vm.evalLevel == '正常' || _vm.evalLevel == '睡眠质量很好')) ? _c('div', {
    staticClass: "xl-font text-center",
    staticStyle: {
      "color": "#4ba7e8"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.evalLevel))])]) : _vm._e(), _vm._v(" "), (_vm.examType == '3' && _vm.evalLevel != '' && (_vm.evalLevel != '无症状' && _vm.evalLevel != '正常' && _vm.evalLevel != '睡眠质量很好')) ? _c('div', {
    staticClass: "xl-font text-center",
    staticStyle: {
      "color": "red"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.evalLevel))])]) : _vm._e(), _vm._v(" "), (_vm.examType != '3') ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [(_vm.remark) ? _c('p', {
    staticClass: "m-font gray-text"
  }, [_vm._v(_vm._s(_vm.remark))]) : _vm._e(), _vm._v(" "), (_vm.eval) ? _c('hr') : _vm._e(), (_vm.eval) ? _c('p', {
    staticClass: "cyan-text l-font"
  }, [_vm._v("描述")]) : _vm._e(), _vm._v(" "), (_vm.eval) ? _c('p', {
    staticClass: "m-font gray-text"
  }, [_vm._v(_vm._s(_vm.eval))]) : _vm._e(), _vm._v(" "), (_vm.suggest) ? _c('hr') : _vm._e(), (_vm.suggest) ? _c('p', {
    staticClass: "cyan-text l-font"
  }, [_vm._v("建议")]) : _vm._e(), _vm._v(" "), (_vm.suggest) ? _c('p', {
    staticClass: "m-font gray-text",
    domProps: {
      "innerHTML": _vm._s(_vm.suggest)
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    staticStyle: {
      "height": "150px"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "img-box"
  }), _vm._v(" "), _c('div', {
    staticClass: "btngroup"
  }, [_c('x-button', {
    staticClass: "cancelBtn",
    nativeOn: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": "加载中..."
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47240a0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/exam/startExam.vue
// module id = Wq2K
// module chunks = 6